import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Typography } from "antd";

import { useCampaigns, useTableCampaigns } from "../hooks";
import Table from "../../../shared/components/ui/Table";
import { campaignsService } from "../../../shared/services";
import { DataCampaigns } from "../../../redux/@types";
import { TableColumns } from "../../../shared/components/ui/Table/types";

const { Title } = Typography;

export const TableCampaigns = () => {
  const { changeCampaignForUpdate, showDeleteConfirm } = useTableCampaigns();
  const { setTableProps, updateStatus, isLoading } = useCampaigns();

  const columns: TableColumns<DataCampaigns> = [
    {
      title: "ID",
      width: 3,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Nombre",
      width: 8,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Slug",
      width: 8,
      dataIndex: "slug",
      key: "slug",
      filterType: "text",
    },
    {
      title: "Modo productos",
      width: 6,
      dataIndex: "products_mode",
      key: "products_mode",
    },
    {
      title: "Estado",
      width: 7,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <button
              disabled={isLoading}
              onClick={() => {
                if (item.status === "active") {
                  updateStatus("inactive", item.id);
                } else if (item.status === "inactive") {
                  updateStatus("active", item.id);
                }
              }}
              style={{
                display: "flex",
                padding: "5px 27px",
                borderWidth: 0,
                cursor: "pointer",
                borderRadius: "20px",
                backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
              }}
            >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                }}
                level={5}
              >
                {item.status}
              </Title>
            </button>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 6,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeCampaignForUpdate(item)}
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.name}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<DataCampaigns>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={campaignsService}
      onLoad={setTableProps}
    />
  );
};
